import Dinero from "dinero.js";

export const Money = Dinero;
Money.defaultCurrency = "EUR";
Money.defaultPrecision = 2;
Money.globalLocale = "de-DE";

// eslint-disable-next-line no-redeclare
export type Money = ReturnType<typeof Money>;
